module.exports = "<a ng-click=\"exportPostsConfirmation()\" translate=\"app.export_to_csv\">Export filtered data</a>\n";